export enum PaymentAction {
  ADD = 'Add',
  SUBTRACT = 'Subtract',
}
